'use client';
import StatCard from '../../StatCard';

type Stat = {
  time: string;
  value: number;
};

type Props = {
  stats: Stat[];
  lastUpdatedTimes: string[];
  setStatValues: React.Dispatch<React.SetStateAction<Stat[]>>;
};

const WithdrawalTickerDesktop: FC<Props> = ({ stats, lastUpdatedTimes }) => (
  <div className="grid grid-cols-3 gap-4 mt-2">
    {stats.map(({ time, value }) => (
      <StatCard
        key={time}
        time={time}
        value={value}
        textSize="lg:text-[28px] xl:text-[40px]"
        onClick={() => {}}
        animate={lastUpdatedTimes.includes(time)}
      />
    ))}
  </div>
);

export default WithdrawalTickerDesktop;
